<template>
  <div>
    <div class="modal-card">
      <header>
        <div class="modal-card-head">
          <h4 class="modal-card-title">Select Object Groups</h4>
          <div class="is-divider-vertical"></div>
        </div>
      </header>
      <section class="modal-card-body is-size-2 is-marginless">
        <div class="columns is-marginless">
          <div class="column p-0">
            <search-bar :shouldEmit="true" @search="getSearchValue($event)" placeholder="Search">
            </search-bar>
          </div>
        </div>
        <div class="table-container">
          <mf-table :tableProps="tableProps" :loadData="loadData" ref="itemTable" :hideGutter="true" :apiMode="true"
                    :key="rerenderMfTable"
                    :checkedRows="selectedItems"
                    @checkbox-toggled="getSelectedRows">
            
          </mf-table>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-flex-end">
        <button class="button is-outlined" @click="cancel()">Cancel</button>
        <button class="button has-background-black-bis" @click="addItems()">Add</button>
      </footer>
    </div>
    <o-loading :full-page="false" :active="isLoading" :can-cancel="true"></o-loading>
  </div>
</template>

<script>
import { defineComponent, onBeforeMount, onMounted, reactive, ref, toRefs } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import SearchBar from '@/components/SearchBar.vue';
import MfTable from '@/components/table-fields/MfTable.vue';
import { isEmpty } from 'lodash';

export default defineComponent({
  name: 'AddItemsByObjectGroup',
  components: {
    MfTable,
    SearchBar,
  },
  props: {
    groupedItems: {
      type: Array
    },
    groupingParameter: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const tableCols = {
      defaultSortField: 'name',
      defaultSortOrder: 'asc',
      rearrangeCols: false,
      isCheckable: true,
      detailRowComponent: 'mf-detail-row',
      customRowKey: 'uuid',
      fields: [
        {
          name: 'field-generic-input',
          width: '920px !important', // i have added important to override mf-table css
          title: props.groupingParameter,
          id: 'name',
          prop: 'name',
        }
      ]
    }
    const itemTable = ref(null);
    const route = useRoute();
    const store = useStore();
    const state = reactive({
      tableProps: tableCols,
      isLoading: false,
      searchKey: '',
      rerenderMfTable: 0,
      selectedItems: []
    });

    const loadData = async () => {
      let data = props.groupedItems;
      if(!isEmpty(props.groupedItems)) {
        if(state.searchKey) {
          data = data.filter(x => x.name.includes(state.searchKey));
        }
        return { data: data, total: data.length };
      } else {
        return[];
      }

    };

    const getSearchValue = async (searchText) => {
      state.searchKey = searchText;
      state.rerenderMfTable++;
    };

    const cancel = () => {
      emit('close', false);
    };

    const getSelectedRows = (item) => {
      state.selectedItems = item;
    };

    const addItems = () => {
      emit("itemsToAdd", state.selectedItems);
      emit('close', false);
    }

    return {
      ...toRefs(state),
      cancel,
      getSearchValue,
      loadData,
      itemTable,
      addItems,
      getSelectedRows
    }
  }
})
</script>